// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-container {
  background-color: #3d200d;
  padding: 0.1rem 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}


  
  .footer-subscription {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  
    margin-bottom: 24px;
    padding: 24px;
    color: #fff;
  }
  
  .footer-subscription > p {
    font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande',
      'Lucida Sans', Arial, sans-serif;
  }
  
  .footer-subscription-heading {
    margin-bottom: 24px;
    font-size: 24px;
  }
  
  .footer-subscription-text {
    margin-bottom: 24px;
    font-size: 20px;
  }
  
  .footer-input {
    padding: 8px 20px;
    border-radius: 2px;
    margin-right: 10px;
    outline: none;
    border: none;
    font-size: 18px;
    margin-bottom: 16px;
    border: 1px solid #fff;
  }
  
  .footer-links {
    width: 100%;
    max-width: 1000px;
    display: flex;
    justify-content: center;
  }
  
  .footer-link-wrapper {
    display: flex;
  }
  
  .footer-link-items {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 16px;
    text-align: left;
    width: 160px;
    box-sizing: border-box;
  }
  
  .footer-link-items h2 {
    margin-bottom: 16px;
  }
  
  .footer-link-items > h2 {
    color: #fff;
  }
  
  .footer-link-items a {
    color: #fff;
    text-decoration: none;
    margin-bottom: 0.5rem;
  }
  
  .footer-link-items a:hover {
    color: #e9e9e9;
    transition: 0.3s ease-out;
  }
  
  .footer-email-form h2 {
    margin-bottom: 2rem;
  }
  

  /* for the email input text "Your Email" */
  .footer-input::placeholder {
    color: #b1b1b1;
  }
  
  /* Social Icons */
  .social-icon-link {
    color: #fff;
    font-size: 24px;
  }
  
  .social-media {
    max-width: 1000px;
    width: 100%;
  }
  
  .social-media-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 90%;
    max-width: 1000px;
    margin: 40px auto 0 auto;
  }
  
  .social-icons {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    width: 240px;
    margin-top: -25px;
  }
  
  .social-logo {
    color: #fff;
    justify-self: start;
    margin-left: 20px;
    cursor: pointer;
    text-decoration: none;
    font-size: 2rem;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  
  .website-rights {
    color: #fff;
    margin-bottom: 16px;
  }



  /*****************************************  ***********************************************/

  

  
  
  @media screen and (max-width: 820px) {
    .footer-links {
      padding-top: 2rem;
    }
  
    .footer-input {
      width: 100%;
    }
  
    .btn {
      width: 100%;
    }
  
    .footer-link-wrapper {
      flex-direction: column;
    }
  
    .social-media-wrap {
      flex-direction: column;
    }

    .social-icons {
      margin-top: 0px;
    }

  }
  
  @media screen and (max-width: 768px) {
  }`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;;;EAIE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;;IAElB,mBAAmB;IACnB,aAAa;IACb,WAAW;EACb;;EAEA;IACE;sCACkC;EACpC;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;;EAGA,0CAA0C;EAC1C;IACE,cAAc;EAChB;;EAEA,iBAAiB;EACjB;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;IACpB,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;;;EAIA,2FAA2F;;;;;;EAM3F;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,eAAe;IACjB;;EAEF;;EAEA;EACA","sourcesContent":[".footer-container {\n  background-color: #3d200d;\n  padding: 0.1rem 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n\n  \n  .footer-subscription {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n  \n    margin-bottom: 24px;\n    padding: 24px;\n    color: #fff;\n  }\n  \n  .footer-subscription > p {\n    font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande',\n      'Lucida Sans', Arial, sans-serif;\n  }\n  \n  .footer-subscription-heading {\n    margin-bottom: 24px;\n    font-size: 24px;\n  }\n  \n  .footer-subscription-text {\n    margin-bottom: 24px;\n    font-size: 20px;\n  }\n  \n  .footer-input {\n    padding: 8px 20px;\n    border-radius: 2px;\n    margin-right: 10px;\n    outline: none;\n    border: none;\n    font-size: 18px;\n    margin-bottom: 16px;\n    border: 1px solid #fff;\n  }\n  \n  .footer-links {\n    width: 100%;\n    max-width: 1000px;\n    display: flex;\n    justify-content: center;\n  }\n  \n  .footer-link-wrapper {\n    display: flex;\n  }\n  \n  .footer-link-items {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    margin: 16px;\n    text-align: left;\n    width: 160px;\n    box-sizing: border-box;\n  }\n  \n  .footer-link-items h2 {\n    margin-bottom: 16px;\n  }\n  \n  .footer-link-items > h2 {\n    color: #fff;\n  }\n  \n  .footer-link-items a {\n    color: #fff;\n    text-decoration: none;\n    margin-bottom: 0.5rem;\n  }\n  \n  .footer-link-items a:hover {\n    color: #e9e9e9;\n    transition: 0.3s ease-out;\n  }\n  \n  .footer-email-form h2 {\n    margin-bottom: 2rem;\n  }\n  \n\n  /* for the email input text \"Your Email\" */\n  .footer-input::placeholder {\n    color: #b1b1b1;\n  }\n  \n  /* Social Icons */\n  .social-icon-link {\n    color: #fff;\n    font-size: 24px;\n  }\n  \n  .social-media {\n    max-width: 1000px;\n    width: 100%;\n  }\n  \n  .social-media-wrap {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 90%;\n    max-width: 1000px;\n    margin: 40px auto 0 auto;\n  }\n  \n  .social-icons {\n    display: inline-flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 240px;\n    margin-top: -25px;\n  }\n  \n  .social-logo {\n    color: #fff;\n    justify-self: start;\n    margin-left: 20px;\n    cursor: pointer;\n    text-decoration: none;\n    font-size: 2rem;\n    display: flex;\n    align-items: center;\n    margin-bottom: 16px;\n  }\n  \n  .website-rights {\n    color: #fff;\n    margin-bottom: 16px;\n  }\n\n\n\n  /*****************************************  ***********************************************/\n\n  \n\n  \n  \n  @media screen and (max-width: 820px) {\n    .footer-links {\n      padding-top: 2rem;\n    }\n  \n    .footer-input {\n      width: 100%;\n    }\n  \n    .btn {\n      width: 100%;\n    }\n  \n    .footer-link-wrapper {\n      flex-direction: column;\n    }\n  \n    .social-media-wrap {\n      flex-direction: column;\n    }\n\n    .social-icons {\n      margin-top: 0px;\n    }\n\n  }\n  \n  @media screen and (max-width: 768px) {\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
